import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/my-teachers`;

export const myTeachersRoutesObj = {
  list: baseRoute,
} as const;

export type IMyTeachersRouteParams = IExtractRouteParamMap<
  typeof myTeachersRoutesObj
>;

export const myTeachersPath = createPaths<
  typeof myTeachersRoutesObj,
  IMyTeachersRouteParams
>(myTeachersRoutesObj);
